import { render } from "./FeaturesComponent.vue?vue&type=template&id=a357b690&scoped=true"
const script = {}

import "./FeaturesComponent.vue?vue&type=style&index=0&id=a357b690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a357b690"]])

export default __exports__